<template>
    <div class="overview-editor">
        <TotemToast ref="toast" />
        <div class="overview-editor__actions">
            <TotemButton size="small" icon="pencil" @click="toggleNotes" v-if="showNotes" :label="$t('CourseOverviewEditor.hide_memo')" />
            <TotemButton size="small" icon="pencil" @click="toggleNotes" v-if="!showNotes" :label="$t('CourseOverviewEditor.show_memo')" />
            <TotemButton size="small" class="-margin-left" v-if="showNotes" @click="saveNote" :label="$t('CourseOverviewEditor.save_memo')" />
        </div>
        <TotemEditor :height="78" v-if="showNotes" class="overview-editor__totem-editor" v-model="newNoteContent" :content="currentNoteContent" :autoFocus="true" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        props: {
            courseId: [ Number, String ],
            courseTitle: String
        },
        computed: {
            ...mapGetters({
                getNoteForCourse: 'Notes/getNoteForCourse'
            })
        },
        methods: {
            toggleNotes () {
                this.showNotes = !this.showNotes
            },
            async saveNote () {
                await this.$store.dispatch('Notes/UpsertNote', { courseId: this.courseId, content: this.newNoteContent })
                this.currentNoteContent = this.newNoteContent
                this.$refs.toast.show(this.$t('CourseOverviewEditor.memo_saved'))
            },
            autoSaveNote () {
                let lastNote = this.currentNoteContent
                this.checkingMemoNotes = setInterval(() => {
                    if (lastNote !== this.newNoteContent) {
                        this.$store.dispatch('Notes/UpsertNote', { courseId: this.courseId, content: this.newNoteContent })
                        lastNote = this.newNoteContent
                        this.currentNoteContent = this.newNoteContent
                    }
                }, 5000)
            }
        },
        data () {
            return {
                showNotes: null,
                currentNoteContent: null,
                newNoteContent: null,
                checkingMemoNotes: null
            }
        },
        async created () {
            await this.$store.dispatch('Notes/loadNotes')
            let note = this.getNoteForCourse(this.courseId)
            if (note) {
                this.currentNoteContent = note.content
            }
            this.autoSaveNote()
        },
        mounted () {
            this.showNotes = !this.isMobileView
        },
        beforeDestroy () {
            clearInterval(this.checkingMemoNotes)
        }
    }
</script>

<style lang="scss" scoped>
    .overview-editor {
        position: relative;
        margin: 15px 0 0 0;

        &__actions {
            display: flex;
            align-items: center;
            margin: 0 0 15px;
        }

        &__actions button {
            [class*="mobile_sm"] & {
                font-size: 1.1rem;
            }
        }

        &__totem-editor {
            margin: 0 0 30px;
        }

        &__review-button {
            margin: 0 10px 0 auto;
        }
    }
</style>
